import { StyleSheet } from 'react-native';
import theme from '../../common/theme';

export const styles = StyleSheet.create({
  container: {
    rowGap: 8,
    position: 'absolute',
    bottom: 32,
    opacity: 0.8,
  },
  text: {
    fontSize: 12,
    lineHeight: 14,
    textAlign: 'center',
    fontFamily: theme.fonts.regular,
    color: theme.palette.white,
  },
  textDark: {
    color: theme.palette.black,
  },
});
